import { render, staticRenderFns } from "./AddBmdCTD.vue?vue&type=template&id=4d5ac740&scoped=true&"
import script from "./AddBmdCTD.vue?vue&type=script&lang=js&"
export * from "./AddBmdCTD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ac740",
  null
  
)

export default component.exports